import { gql } from "@apollo/client";

import { SEAT_MAP_FRAGMENT } from "./fragments";

export const CREATE_SEAT_MAP = gql`
  ${SEAT_MAP_FRAGMENT}
  mutation CreateSeatMap($input: SeatMapCreateInput!) {
    seatMapCreate(input: $input) {
      ...SeatMap
    }
  }
`;
